// extracted by mini-css-extract-plugin
export default {"illustration":"UserOnboardingLocationSlide_illustration__ReWgI"};